import React, { useEffect, useContext, useState } from "react";
import PropTypes from "prop-types";
import { isEqual, xor } from "lodash";
import { VariantContextData } from "../variants/VariantBuilderContext";
import arePropsEqual from "../../utils/arePropsEqual";
import ElementText from "../elements/ElementText";
import ElementImage from "../elements/ElementImage";
import ElementButton from "../elements/ElementButton";
import ElementHtml from "../elements/ElementHtml";
import ElementRow from "../elements/ElementRow";
import ElementForm from "../elements/ElementForm";
import ElementSurvey from "../elements/ElementSurvey";
import ElementVideo from "../elements/ElementVideo";
import ElementDivider from "../elements/ElementDivider";
import ElementIcon from "../elements/ElementIcon";
import ElementList from "../elements/ElementList";
import ElementTimer from "../elements/ElementTimer";
import ElementProgress from "./ElementProgress";
import ElementProducts from "./ElementProducts";
import ElementProductHero from "../elements/ElementProductHero";
import ElementCollapse from "./ElementCollapse";
import ElementTabs from "../elements/ElementTabs";
import ElementCarousel from "../elements/ElementCarousel";
import ElementQuiz from "../elements/ElementQuiz";
import ElementSpacingHandle from "../elements/ElementSpacingHandle";
import ElementConditionalRow from "../elements/ElementConditionalRow";
import ElementLogo from "../elements/ElementLogo";
import ElementNavigation from "../elements/ElementNavigation";
import ElementReviews from "../elements/ElementReviews";
import ElementScheduler from "../elements/ElementScheduler";
import ElementTicker from "../elements/ElementTicker";
import ElementEmbed from "../elements/ElementEmbed";
import BuilderSkeletonPlaceholder from "../variants/BuilderSkeletonPlaceholder";
import {
  buildElementStylesheet,
  resolveElementClasses,
} from "./ElementStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";

const Element = (props) => {
  let cta = props.cta;
  let element = props.element;

  if (element.placeholder == true) {
    return (
      <div
        id={"element" + element.id}
        data-element-id={element.id}
        data-section-id={element.section_id}
        data-sortable-id={element.column}
        data-pos={element.position}
        data-object-type="elements"
        data-object-id={element.id}
        className="cf-cta-item cf-element pointer-events-none"
      >
        <BuilderSkeletonPlaceholder object_type="elements" />
      </div>
    );
  }

  let options = element.options;
  let classes = resolveElementClasses(element, false);
  const stylesheet = buildElementStylesheet(
    props.builder,
    props.device,
    props.cta,
    element
  );
  let contextData;
  let builder;
  let selected;

  if (props.builder == true) {
    [contextData, builder] = useContext(VariantContextData);
    selected = builder.selected();
  }

  const showBuilderSpacingHandles =
    props.builder == true &&
    contextData.selected_object_type == "elements" &&
    contextData.selected_object_id == element.id;

  if (props.builder == true) {
    if (
      contextData.selected_object_type == "elements" &&
      contextData.selected_object_id == element.id &&
      contextData.selected_object_editing == true
    ) {
      classes = resolveElementClasses(element, true);
    }
    useEffect(() => {
      if (!["form", "survey"].includes(element.element_type)) return;
      const element_tag = document.querySelector(
        '#builder .cf-element[data-element-id="' + element.id + '"]'
      );
      if (!element_tag) return;
      $(element_tag)
        .find(".cf-form-field ")
        .sort(function (a, b) {
          return $(a).attr("data-pos") - $(b).attr("data-pos");
        })
        .prependTo($(element_tag).find(".cf-form-fields"));
    }, [element]);
  }

  return (
    <React.Fragment>
      <div
        id={"element" + element.id}
        data-id={element.id}
        data-element-id={element.id}
        data-type={element.element_type}
        section-id={element.section_id}
        data-section-id={element.section_id}
        sortable-id={element.column}
        data-sortable-id={element.column}
        data-pos={element.position}
        data-object-type="elements"
        data-object-id={element.id}
        className={
          classes +
          (props.builder == true &&
          selected &&
          selected.object_type == "elements" &&
          selected.object_id == element.id
            ? " editor-select"
            : "")
        }
      >
        <BuilderStyleTag
          builder={props.builder}
          styleKey={`cta:${cta.id}:element:${element.id}:wrapper`}
          stylesheet={stylesheet}
        />
        {(element.element_type == "text" ||
          element.element_type == "headline") && (
          <ElementText {...props}></ElementText>
        )}
        {element.element_type == "image" && (
          <ElementImage {...props}></ElementImage>
        )}
        {element.element_type == "button" && (
          <ElementButton {...props}></ElementButton>
        )}
        {element.element_type == "html" && (
          <ElementHtml {...props}></ElementHtml>
        )}
        {element.element_type == "form" && (
          <ElementForm {...props}></ElementForm>
        )}
        {element.element_type == "survey" && (
          <ElementSurvey {...props}></ElementSurvey>
        )}
        {element.element_type == "video" && (
          <ElementVideo {...props}></ElementVideo>
        )}
        {element.element_type == "divider" && (
          <ElementDivider {...props}></ElementDivider>
        )}
        {element.element_type == "icon" && (
          <ElementIcon {...props}></ElementIcon>
        )}
        {element.element_type == "list" && (
          <ElementList {...props}></ElementList>
        )}
        {element.element_type == "tabs" && (
          <ElementTabs {...props}></ElementTabs>
        )}
        {element.element_type == "carousel" && (
          <ElementCarousel {...props}></ElementCarousel>
        )}
        {element.element_type == "ticker" && (
          <ElementTicker {...props}></ElementTicker>
        )}
        {element.element_type == "quiz" && (
          <ElementQuiz {...props}></ElementQuiz>
        )}
        {element.element_type == "conditional_row" && (
          <ElementConditionalRow {...props} />
        )}
        {element.element_type == "timer" && (
          <ElementTimer {...props}></ElementTimer>
        )}
        {element.element_type == "progress" && (
          <ElementProgress {...props}></ElementProgress>
        )}
        {element.element_type == "products" && (
          <ElementProducts {...props}></ElementProducts>
        )}
        {element.element_type == "product_hero" && (
          <ElementProductHero {...props}></ElementProductHero>
        )}
        {element.element_type == "collapse" && (
          <ElementCollapse {...props}></ElementCollapse>
        )}
        {element.element_type == "logo" && (
          <ElementLogo {...props}></ElementLogo>
        )}
        {element.element_type == "navigation" && (
          <ElementNavigation {...props}></ElementNavigation>
        )}
        {element.element_type == "reviews" && (
          <ElementReviews {...props}></ElementReviews>
        )}
        {element.element_type == "embed" && (
          <ElementEmbed {...props}></ElementEmbed>
        )}
        {element.element_type == "scheduler" && (
          <ElementScheduler {...props}></ElementScheduler>
        )}
        {element.element_type == "row" && <ElementRow {...props}></ElementRow>}
        {showBuilderSpacingHandles && (
          <React.Fragment>
            <ElementSpacingHandle
              key={`element-${element.id}-spacer-top`}
              {...props}
              direction="top"
            ></ElementSpacingHandle>
            <ElementSpacingHandle
              key={`element-${element.id}-spacer-bottom`}
              {...props}
              direction="bottom"
            ></ElementSpacingHandle>
            <ElementSpacingHandle
              key={`element-${element.id}-spacer-left`}
              {...props}
              direction="left"
            ></ElementSpacingHandle>
            <ElementSpacingHandle
              key={`element-${element.id}-spacer-right`}
              {...props}
              direction="right"
            ></ElementSpacingHandle>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default React.memo(Element, arePropsEqual);
